import * as React from "react";

import { AppContext } from "./AppContext";
import { makeAppContextValue } from "./makeAppContextValue";

export interface AppWindowProviderProps {
  appWindow: Window;
}

/**
 * Component that provides its children an ability to use the proper window via context.
 * Use this instead of specifying AppContext.Provider directly
 */
export const AppWindowProvider = ({
  appWindow,
  children,
}: React.PropsWithChildren<AppWindowProviderProps>) => {
  return (
    <AppContext.Consumer>
      {(context) => (
        <AppContext.Provider
          value={makeAppContextValue(
            context.isExperimentalFeatureEnabled,
            context.setTooltipElement,
            context.updateTooltipsHidden,
            appWindow,
            context.isPlatformFeatureEnabled
          )}
        >
          {children}
        </AppContext.Provider>
      )}
    </AppContext.Consumer>
  );
};
